













































































































































import { Component, Mixins } from 'vue-property-decorator';

import { View } from 'client-website-ts-library/plugins';

import ItemCycler from '@/components/Cycler/ItemCycler.vue';

import { ItemCyclerSlide, ItemCyclerImageSlide } from '@/app_code/ItemCycler';

@Component({
  components: {
    ItemCycler,
  },
})
export default class Home extends Mixins(View) {
  private cyclerImages: ItemCyclerSlide[] = [
    new ItemCyclerImageSlide({
      source: '/assets/images/home/slider/1',
      formats: ['avif', 'webp', 'jpg'],
      fallback: 'jpg',
    }),
    new ItemCyclerImageSlide({
      source: '/assets/images/home/slider/2',
      formats: ['avif', 'webp', 'jpg'],
      fallback: 'jpg',
    }),
    new ItemCyclerImageSlide({
      source: '/assets/images/home/slider/3',
      formats: ['avif', 'webp', 'jpg'],
      fallback: 'jpg',
    }),
  ];
}
